<template>
    <div>
        <input
            :name="name"
            type="text"
            :placeholder="placeholder"
            :required="required"
            class="h-11 border-gray-300 py-2 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full"
            :class="[
                hasError ? 'border-red-500 bg-red-100' : '',
                extraClasses,
            ]"
            ref="datepicker"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
        />
    </div>
</template>

<script>
import {usePage} from '@inertiajs/inertia-vue3'

import flatpickr from "flatpickr";
import { Danish } from "flatpickr/dist/l10n/da.js"

export default {
    props: {
        modelValue: {
            type: [String, Number],
            default: '',
        },
        mode: {
            type: String,
            default: 'date',
        },
        name: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        extraClasses: {
            type: String,
            default: null
        },
        defaultDate: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            modes: {
                'date': {
                    'dateFormat': 'Y-m-d',
                    'altFormat': 'd-m-Y',
                    'enableTime': false,
                    'noCalendar': false,
                },
                'time': {
                    'dateFormat': 'H:i:S',
                    'altFormat': 'H:i:S',
                    'enableTime': true,
                    'noCalendar': true,
                },
                'datetime': {
                    'dateFormat': 'Y-m-d H:i',
                    'altFormat': 'd-m-Y H:i',
                    'enableTime': true,
                    'noCalendar': false,
                },
            },
            fp: null,
        }
    },
    emits: ['update:modelValue'],
    mounted() {
        this.fp = flatpickr(this.$refs.datepicker, {
            locale: usePage().props.value.__locale,
            maxDate: null,
            enableTime: this.modes[this.mode].enableTime,
            enableSeconds: this.modes[this.mode].enableTime,
            time_24hr: true,
            dateFormat: this.modes[this.mode].dateFormat,
            altInput: true,
            //altFormat: this.mode === 'date' ? 'j. F, Y' : 'j. F, Y H.i',
            altFormat: this.modes[this.mode].altFormat,
            noCalendar: this.modes[this.mode].noCalendar,
            //disableMobile: "true",
            static: false,
            defaultDate: this.defaultDate,
        });

        if (this.$refs.datepicker.value !== this.modelValue) {
            this.$emit('update:modelValue', this.$refs.datepicker.value);
        }
    },
    watch: {
        modelValue(newVal) {
            if (this.fp && newVal !== this.fp.selectedDates[0]) {
                this.fp.setDate(newVal, false);
            }
        }
    },
}
</script>
